import { render, staticRenderFns } from "./ResponseGroupManager.vue?vue&type=template&id=584207c1&scoped=true"
import script from "./ResponseGroupManager.vue?vue&type=script&lang=ts"
export * from "./ResponseGroupManager.vue?vue&type=script&lang=ts"
import style0 from "./ResponseGroupManager.vue?vue&type=style&index=0&id=584207c1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "584207c1",
  null
  
)

export default component.exports